module.exports = __webpack_public_path__ + "img/close.87a6b7a3.svg";